var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vux-toast" },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowMask && _vm.show,
            expression: "isShowMask && show"
          }
        ],
        staticClass: "weui-mask_transparent"
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: _vm.currentTransition } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show,
                expression: "show"
              }
            ],
            staticClass: "weui-toast",
            class: _vm.toastClass,
            style: { width: _vm.width }
          },
          [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.type !== "text",
                  expression: "type !== 'text'"
                }
              ],
              staticClass: "weui-icon-success-no-circle weui-icon_toast"
            }),
            _vm._v(" "),
            _vm.text
              ? _c("p", {
                  staticClass: "weui-toast__content",
                  style: _vm.style,
                  domProps: { innerHTML: _vm._s(_vm.text) }
                })
              : _c(
                  "p",
                  { staticClass: "weui-toast__content", style: _vm.style },
                  [_vm._t("default")],
                  2
                )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14ee3e0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ee3e0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
// module id = null
// module chunks = 